module.exports = __webpack_public_path__ + "img/Group_11.44c2b8c5.png";